// src/pages/mission/Mission.utils.js
// Utility functions for mission page

import { SOLDIER_CLASSES } from '../../componets/classes';

/**
 * Get soldier class configuration
 */
export const getSoldierClass = (soldier) => {
  if (!soldier.class) return null;
  return SOLDIER_CLASSES[soldier.class];
};

/**
 * Format soldier name with nickname if available
 */
export const formatSoldierName = (soldier) => {
  if (soldier.nickname) {
    return `${soldier.name} "${soldier.nickname}"`;
  }
  return soldier.name;
};

/**
 * Calculate health percentage
 */
export const getHealthPercentage = (health, maxHealth) => {
  return Math.round(((health || 100) / (maxHealth || 100)) * 100);
};

/**
 * Format duration in minutes
 */
export const formatDuration = (seconds) => {
  if (!seconds) return 'Variable';
  return `${Math.floor(seconds / 60)} minutes`;
};

/**
 * Attach loadouts to squad members
 */
export const attachLoadoutsToSquad = (squad, getLoadout) => {
  return squad.map(s => ({
    ...s,
    loadout: getLoadout(s.id)
  }));
};

/**
 * Check if equipment item is selected for soldier
 */
export const isEquipmentSelected = (loadout, slot, itemId) => {
  return loadout?.[slot] === itemId;
};